import { writable } from 'svelte/store';

export const msg = writable({msg:""});

export function showMsg(s) {
  // console.log("showMsg", s)
  msg.set({msg:s, style: ""});
}

export function clearMsg() {
  msg.set({msg:""});
}

